import { render, staticRenderFns } from "./StaticPageChrome.vue?vue&type=template&id=5c6f9ecb&"
import script from "./StaticPageChrome.vue?vue&type=script&lang=js&"
export * from "./StaticPageChrome.vue?vue&type=script&lang=js&"
import style0 from "./StaticPageChrome.vue?vue&type=style&index=0&module=true&lang=module.css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports